Shopify.formatMoney = function(cents, format) {
if (typeof cents == 'string') {
cents = cents.replace('.', '');
}
var value = '';
var placeholderRegex = /{{\s*(\w+)\s*}}/;
Shopify.money_format = "€{{amount}}";
var formatString = (format || Shopify.money_format);
function defaultOption(opt, def) {
   return (typeof opt == 'undefined' ? def : opt);
}
function formatWithDelimiters(number, precision, thousands, decimal) {
   precision = defaultOption(precision, 2);
   thousands = defaultOption(thousands, ',');
   decimal = defaultOption(decimal, '.');
   if (isNaN(number) || number == null) {
       return 0;
   }
   number = (number / 100.0).toFixed(precision);
   var parts = number.split('.'),
       dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
       cents = parts[1] ? (decimal + parts[1]) : '';
   return dollars + cents;
}
switch (formatString.match(placeholderRegex)[1]) {
   case 'amount':
       value = formatWithDelimiters(cents, 2);
       break;
   case 'amount_no_decimals':
       value = formatWithDelimiters(cents, 0);
       break;
   case 'amount_with_comma_separator':
       value = formatWithDelimiters(cents, 2, '.', ',');
       break;
   case 'amount_no_decimals_with_comma_separator':
       value = formatWithDelimiters(cents, 0, '.', ',');
       break;
}
return formatString.replace(placeholderRegex, value);
};


// Breadcrumbs - once users land on collection page, save the date to localStorage
if (window.location.pathname.includes("/collections/")) {
  localStorage.setItem("last_collection_url", window.location.pathname);
  const collectionTitle = document.querySelector("[data-collection-title]");
  if (collectionTitle) {
    localStorage.setItem(
      "last_collection_title",
      collectionTitle.textContent.trim()
    );
  }
}



document.querySelectorAll('.accordion').forEach(acc => {
 const headline = acc.querySelector('.acc_headline');
 const content  = acc.querySelector('.acc_content');


 if(headline){
 headline.addEventListener('click', () => {
   const isOpen = acc.hasAttribute('open');


   if (isOpen) {
     content.style.maxHeight = content.scrollHeight + 'px';
     requestAnimationFrame(() => {
       content.style.maxHeight = '0px';
     });
     acc.removeAttribute('open');
   } else {
     content.style.maxHeight = content.scrollHeight + 'px';
     acc.setAttribute('open', '');
   }
 });
}
if(content) {
 content.addEventListener('transitionend', () => {
   if (acc.hasAttribute('open')) {
     content.style.maxHeight = 'none';
   }
 });
}
});




if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      filterCountries() {
        const searchValue = this.elements.search.value.toLowerCase();
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = item.querySelector('.country').textContent.toLowerCase();
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }
        
      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}



// Cart buble count

(() => {
  function setCartCountBubble(count) {
    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return count;

    let num = bubble.querySelector('.cart-count-number');
    
    if (!num) {
      num = document.createElement('span');
      num.className = 'cart-count-number body-xs';
      num.setAttribute('aria-hidden', 'true');
      bubble.appendChild(num);
    }
    num.textContent = String(count);    

    if (count > 0) {
     bubble.style.display = 'flex';
    } else {
     bubble.style.display = 'none';
    }

    return count;
  }

  // Globalno dostupno
  window.updateCartCount = async function (input) {
    try {
      let count;

      if (typeof input === 'number') {
        count = input;
      } else if (input && typeof input.item_count === 'number') {
        // prosledjen cart objekat
        count = input.item_count;
      } else if (input && input instanceof Response) {
        // eventualno prosledjen fetch Response od /cart*.js
        let cart = null;
        try { cart = await input.clone().json(); } catch {}
        if (cart && typeof cart.item_count === 'number') {
          count = cart.item_count;
        }
      }

      if (typeof count !== 'number') {
        // fallback: povuci /cart.js
        const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return;
        const cart = await res.json();
        count = cart.item_count;
      }

      return setCartCountBubble(count);
      
    } catch (e) {
      console.warn('updateCartCount error:', e);
    }
  };
})();


function initQuizButtons() {
  const buttons = document.querySelectorAll('.quiz-opener-btn');

  buttons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      let chat = document.getElementById('shopify-chat');      
      if (chat) chat.style.visibility = 'hidden';

      const teaser = document.querySelector('[data-testid="animated-teaser"]');      
      if (teaser) teaser.style.display = 'none';
    });
  });
}

document.addEventListener('click', (e) => {  
  const closeBtn = document.querySelector('.rh-widget > span');

  if (closeBtn && e.target === closeBtn) {    
    let chatClose = document.getElementById('shopify-chat');    
    if (chatClose) chatClose.style.visibility = 'visible';

    const teaser = document.querySelector('[data-testid="animated-teaser"]');
    if (teaser) teaser.style.display = '';
  }
})
  
document.addEventListener('DOMContentLoaded', initQuizButtons);





// EMBBLA CAROUSEL
// global.js

// ─── HELPER METHODS ───────────────────────────────────────────────────────────

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  if (prevBtn && nextBtn) {
    const toggleState = () => {
      prevBtn.toggleAttribute("disabled", !emblaApi.canScrollPrev());
      nextBtn.toggleAttribute("disabled", !emblaApi.canScrollNext());
    };

    emblaApi
      .on("init", toggleState)
      .on("select", toggleState)
      .on("reInit", toggleState);

    return () => {
      prevBtn.removeAttribute("disabled");
      nextBtn.removeAttribute("disabled");
    };
  }
};

const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  if (prevBtn && nextBtn) {
    const scrollPrev = () => emblaApi.scrollPrev();
    const scrollNext = () => emblaApi.scrollNext();

    prevBtn.addEventListener("click", scrollPrev);
    nextBtn.addEventListener("click", scrollNext);

    const removeToggle = addTogglePrevNextBtnsActive(
      emblaApi,
      prevBtn,
      nextBtn
    );

    return () => {
      removeToggle();
      prevBtn.removeEventListener("click", scrollPrev);
      nextBtn.removeEventListener("click", scrollNext);
    };
  }
};

const addDotBtnsAndClickHandlers = (svgTypeLabel, emblaApi, dotsNode) => {
  let dotNodes = [];
  const svgType = svgTypeLabel || "tear";

  const buildDots = () => {
    const scrollSnaps = emblaApi.scrollSnapList();

    const html = scrollSnaps
      .map((_, index) => {        
        const label = `Go to slide ${index + 1}`;

        if (svgType === "line") {
          return `
        <button
          class="embla__dot vertical-line-dot"
          type="button"
          aria-label="${label}"
        ></button>`;
        } else {
          return `
        <button
          class="embla__dot"
          type="button"
          aria-label="${label}"          
        >
          <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M3.50022 7.99832C2.56482 7.99832 1.68444 7.65407 1.02415 7.02771C0.363868 6.40302 0 5.57011 0 4.68514C0 3.80017 0.363868 2.96725 1.02415 2.34257L3.50022 0L5.97629 2.34257C7.34124 3.63392 7.34124 5.73636 5.97629 7.02939C5.31423 7.65575 4.43563 8 3.50022 8V7.99832Z" fill="#DEDFE3"/>
          </svg>
        </button>`;
        }
      })
      .join("");

    dotsNode.innerHTML = html;

    dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
    dotNodes.forEach((dot, i) =>
      dot.addEventListener("click", () => emblaApi.scrollTo(i))
    );
  };

  const syncActiveDot = () => {
    const prev = emblaApi.previousScrollSnap();
    const sel = emblaApi.selectedScrollSnap();
    dotNodes[prev]?.classList.remove("embla__dot--selected");
    dotNodes[sel]?.classList.add("embla__dot--selected");
  };

  emblaApi
    .on("init", buildDots)
    .on("reInit", buildDots)
    .on("init", syncActiveDot)
    .on("reInit", syncActiveDot)
    .on("select", syncActiveDot);

  return () => {
    dotsNode.innerHTML = "";
  };
};

// ─── SINGLE CAROUSEL INIT ────────────────────────────────────────────────────

function initEmblaCarousel(emblaNode) {
  const viewport = emblaNode.querySelector(".embla__viewport");
  const prevBtn = emblaNode.querySelector(".embla__button--prev");
  const nextBtn = emblaNode.querySelector(".embla__button--next");
  const dots = emblaNode.querySelector(".embla__dots");
  const svgType = emblaNode.dataset.svg;
  var emblaApi;

  if (viewport.hasAttribute("data-autoplay")) {
    const OPTIONS = { loop: true };
    emblaApi = EmblaCarousel(viewport, OPTIONS, [
      EmblaCarouselAutoplay({ playOnInit: true, delay: 8000 }),
    ]);
  } else {
    emblaApi = EmblaCarousel(viewport, { align: "start" });
  }

  if (prevBtn && nextBtn) {
    const removeBtns = addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn);
    emblaApi.on("destroy", removeBtns);
  }
  if (dots) {
    const removeDots = addDotBtnsAndClickHandlers(svgType, emblaApi, dots);
    emblaApi.on("destroy", removeDots);
  }

  return emblaApi;
}

// ─── GLOBAL INIT FUNCTION ───────────────────────────────────────────────────

/**
 * Initializes every `.embla` carousel on the page.
 * Call this again after you replace any carousel markup.
 */
function initAllEmblaCarousels() {
  document.querySelectorAll(".embla").forEach(initEmblaCarousel);
}

// auto-run on initial page load
document.addEventListener("DOMContentLoaded", initAllEmblaCarousels);

// expose for later calls
window.initAllEmblaCarousels = initAllEmblaCarousels;

const addAutoplayProgressListeners = (emblaApi, progressNode) => {
  const progressBarNode = progressNode.querySelector(".embla__progress__bar");

  let animationName = "";
  let timeoutId = 0;
  let rafId = 0;

  const startProgress = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const timeUntilNext = autoplay.timeUntilNext();
    if (timeUntilNext === null) return;

    if (!animationName) {
      const style = window.getComputedStyle(progressBarNode);
      animationName = style.animationName;
    }

    progressBarNode.style.animationName = "none";
    progressBarNode.style.transform = "translate3d(0,0,0)";

    rafId = window.requestAnimationFrame(() => {
      timeoutId = window.setTimeout(() => {
        progressBarNode.style.animationName = animationName;
        progressBarNode.style.animationDuration = `${timeUntilNext}ms`;
      }, 0);
    });

    progressNode.classList.remove("embla__progress--hidden");
  };

  const stopProgress = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    progressNode.classList.add("embla__progress--hidden");
  };

  emblaApi
    .on("autoplay:timerset", startProgress)
    .on("autoplay:timerstopped", stopProgress);

  return () => {
    emblaApi
      .off("autoplay:timerset", startProgress)
      .off("autoplay:timerstopped", stopProgress);
  };
};

const addPlayBtnListeners = (emblaApi, playBtn) => {
  const togglePlayBtnState = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const buttonText = autoplay.isPlaying() ? "Start" : "Stop";
    playBtn.innerHTML = buttonText;
  };

  const onPlayBtnClick = () => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const playOrStop = autoplay.isPlaying() ? autoplay.stop : autoplay.play;
    playOrStop();
  };

  playBtn.addEventListener("click", onPlayBtnClick);
  emblaApi
    .on("autoplay:play", togglePlayBtnState)
    .on("autoplay:stop", togglePlayBtnState)
    .on("reInit", togglePlayBtnState);

  return () => {
    playBtn.removeEventListener("click", onPlayBtnClick);
    emblaApi
      .off("autoplay:play", togglePlayBtnState)
      .off("autoplay:stop", togglePlayBtnState)
      .off("reInit", togglePlayBtnState);
  };
};

const addNavBtnListeners = (emblaApi, ...navButtons) => {
  const onNavClick = () => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const resetOrStop =
      autoplay.options.stopOnInteraction === false
        ? autoplay.reset
        : autoplay.stop;

    resetOrStop();
  };

  navButtons.forEach((navButton) =>
    navButton.addEventListener("click", onNavClick, true)
  );

  return () => {
    navButtons.forEach((navButton) =>
      navButton.removeEventListener("click", onNavClick, true)
    );
  };
};



window.initDropdowns = () => {
  // Select only dropdowns that have NOT been initialized yet
  const dropdowns = document.querySelectorAll('.jac-dd:not([data-dropdown-initialized])');

  const closeAllMenus = (currentMenu) => {
    document.querySelectorAll('.jac-dd__menu').forEach(m => {
      // Only close other menus
      if (m !== currentMenu && !m.classList.contains('jac-dd__menu-hidden')) {
         m.classList.add('jac-dd__menu-hidden');
         m.closest('.jac-dd')?.querySelector('.jac-dd__button')?.setAttribute('aria-expanded', 'false');
      }
    });
  };

  dropdowns.forEach(dropdown => {
    try {
      const button = dropdown.querySelector('.jac-dd__button');
      const menu = dropdown.querySelector('.jac-dd__menu');
      const label = dropdown.querySelector('[data-dd-label]');
      const idInput = dropdown.closest('[data-product-id]')?.querySelector('input[name="id"]');
      const atc = dropdown.closest('[data-product-id]')?.querySelector('.jac-atc');

      if (!button || !menu) return;

      // Ensure the menu starts hidden
      if (!menu.classList.contains('jac-dd__menu-hidden')) {
          menu.classList.add('jac-dd__menu-hidden');
      }
      
      const openMenu = () => {
        closeAllMenus(menu);
        menu.classList.remove('jac-dd__menu-hidden');
        button.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        menu.classList.add('jac-dd__menu-hidden');
        button.setAttribute('aria-expanded', 'false');
      };

      // 1. Button Click Handler (Toggle)
      const handleButtonClick = (e) => {
          e.stopPropagation(); 
          const isOpen = !menu.classList.contains('jac-dd__menu-hidden');
          if (isOpen) {
            closeMenu();
          } else {
            openMenu();
          }
      };
      // Use remove/add listener to prevent stacking on re-initialization
      button.removeEventListener('click', handleButtonClick);
      button.addEventListener('click', handleButtonClick);


      // 2. Menu Option Click Handler (Selection)
      const handleMenuClick = (e) => {
        e.stopPropagation();
        
        const option = e.target.closest('.jac-dd__option');
        
        if (!option || option.classList.contains('is-disabled')) return;

        // Update active state
        menu.querySelectorAll('.jac-dd__option').forEach(o => o.classList.remove('is-active'));
        option.classList.add('is-active');

        // Update form data
        const sizeLabel = option.dataset.sizeLabel;
        const variantId = option.dataset.variantId;
        if (label) label.textContent = sizeLabel;
        if (idInput) idInput.value = variantId;
        if (atc) atc.disabled = !variantId;

        closeMenu();
      };
      menu.removeEventListener('click', handleMenuClick);
      menu.addEventListener('click', handleMenuClick);
      
      // Mark as initialized
      dropdown.setAttribute('data-dropdown-initialized', true);

    } catch (error) {
      console.error("Error initializing dropdown:", dropdown, error);
    }
  });

  // 3. SINGLE Global Listener for Click-Outside Closure (Attach only once)
  if (!window._jacDropdownsOutsideListenerAttached) {
    document.addEventListener('click', (e) => {
      document.querySelectorAll('.jac-dd').forEach(dropdown => {
        if (dropdown && !dropdown.contains(e.target)) {
          const menu = dropdown.querySelector('.jac-dd__menu');
          const button = dropdown.querySelector('.jac-dd__button');
          if (menu && !menu.classList.contains('jac-dd__menu-hidden')) {
            menu.classList.add('jac-dd__menu-hidden');
            button?.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
    window._jacDropdownsOutsideListenerAttached = true;
  }
};